import { HttpMethod } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import { baseQueryClient, useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { TAX_ID } from '@aibees/shared/workspace/constants/endpoints';
import { AddTaxIdRequest, TaxIdItem } from './types';
import { useBrowseTaxIdApi } from './use-browse-tax-id-api';

export function useAddTaxIdMutation() {
  const notify = useNotify();
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseMutation<AddTaxIdRequest, TaxIdItem>(
    {
      url: TAX_ID.replace(':customerId', workspaceId),
      method: HttpMethod.post,
    },
    {
      onSuccess: () => {
        baseQueryClient.invalidateQueries([
          useBrowseTaxIdApi.name,
          workspaceId,
        ]);
      },
      // onError(error) {
      //   if (error.status === HttpStatusCode.BadRequest)
      //     notify.error('Tax ID is not valid!');
      // },
      doNotShowErrorNotification: true,
    }
  );
}
